import React from "react";
import { styled } from "@material-ui/core/styles";
import Box, { BoxProps } from "@material-ui/core/Box";

const Content = styled(Box)({
  gridColumnStart: 2,
});

const containerVariant = (theme, variant) => {
  switch (variant) {
    case "pink":
      return {
        backgroundColor: theme.palette.primary.main,
      };

    case "grey": {
      return {
        backgroundColor: theme.palette.grey200.main,
      };
    }
    default: {
      return {};
    }
  }
};
// v4 of material ui make typing this very complexe
// and not worth it.
const ContentContainer = styled(Box)(({ theme, variant }: any) => {
  const variantProps = containerVariant(theme, variant);
  return {
    display: "grid",
    backgroundColor: variant === "pink" ? theme.palette.primary.main : "default",
    gridTemplateColumns: "1fr 90% 1fr",
    [theme.breakpoints.up("md")]: {
      gridTemplateColumns: "minmax(48px,1fr) minmax(auto,1400px) minmax(48px,1fr)",
    },
    [theme.breakpoints.up("lg")]: {
      gridTemplateColumns: "minmax(80px,1fr) minmax(auto,1400px) minmax(80px,1fr)",
    },
    ...variantProps,
  };
});

interface ContainerProps extends BoxProps {
  className?: string;
  variant?: "pink" | "grey";
}

const Container: React.FunctionComponent<ContainerProps> = ({ children, className, variant, ...boxProps }) => {
  return (
    <ContentContainer variant={variant} className={className}>
      <Content {...boxProps}>{children}</Content>
    </ContentContainer>
  );
};

export default Container;
